import { useState, useCallback } from 'react';
import axios from 'axios';

export const useImagePreview = () => {
  const [thumbnailUrl, setThumbnailUrl] = useState('');

  const createImageUrl = useCallback(async (base64Image) => {
    try {
      const { data } = await axios.get(base64Image, { responseType: 'blob' });
      setThumbnailUrl(URL.createObjectURL(data));
    } catch (err) {
      console.log(err)
    }
  }, []);

  return { thumbnailUrl, createImageUrl };
};


